<div class="row">
  <div class="col-md-8">
    <div class="d-flex flex-row align-items-center gap-1 mb-3">
      <div class="me-1">
        <ng-select class="period-width" [multiple]="false" [closeOnSelect]="true" [clearable]="false" [(ngModel)]="selectedPeriod"
          [items]="displayPeriods" bindLabel="displayName" bindValue="period" placeholder="Period...">
        </ng-select>
      </div>
      <div class="flex-grow-1 me-1">
        <ng-select [items]="orderableTaskTypes()" [multiple]="false" [closeOnSelect]="true" [searchable]="true" [clearable]="true" (ngModelChange)="onTaskTypeChanged()"
          bindLabel="Name" placeholder="Task Type..." groupBy="IsCustom" [(ngModel)]="selectedTaskType"
          [searchFn]="searchTaskTypes">

          <ng-template ng-label-tmp let-item="item">
            <i [ngClass]="getIconClass(item)"></i>
            <b class="ms-2">{{item.Name}}</b>
            <span> ({{ item.Minutes }} minutes)</span>
          </ng-template>

          <ng-template ng-optgroup-tmp let-item="item">
            {{ item.IsCustom ? 'Manual' : 'Automated' }}
            <div class="float-end">
              Minutes
            </div>
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            <i [ngClass]="getIconClass(item)"
              title="{{ getTitle(item) }}"></i>
            <b class="ms-2">{{item.Name}}</b>
            <span class="float-end">{{ item.Minutes }}</span>
          </ng-template>

        </ng-select>
      </div>
      <div>
        @if (selectedTaskType) {
          @if (showDeactivateButton(selectedTaskType)) {
            <button class="btn btn-secondary" type="button" (click)='deactivate(selectedTaskType)'>Deactivate</button>
          } @else if (selectedTaskType.IsCustom) {
            <button class="btn btn-primary" type="button" (click)="add()" [disabled]="!canBeOrdered(selectedTaskType)">
              <i class="fa fa-plus"></i>Add
            </button>
          } @else if (selectedPeriod === nextAvailablePeriod && canBeNonworkable(selectedTaskType)) {
              <div class="btn-group">
                <button type="button" class="btn btn-primary" [disabled]="!selectedTaskType || !canBeOrdered(selectedTaskType)" (click)="add()"><i class="fa fa-plus"></i>Add</button>
                <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-expanded="false" [disabled]="!selectedTaskType || !canBeOrdered(selectedTaskType)">
                  <span class="visually-hidden">Toggle Dropdown</span>
                </button>
                <ul class="dropdown-menu" role="menu">
                  <li class="text-center">
                    <button class="btn-link dropdown-item" [disabled]="qtyDisabled(1)" (click)="add(1)">{{ 1 }}</button>
                  </li>
                  <div class="dropdown-divider"></div>
                  <li class="text-center">
                    <button class="btn-link dropdown-item" (click)='deactivate(selectedTaskType)'>Deactivate</button>
                  </li>
                </ul>
              </div>
          } @else if(selectedPeriod === nextAvailablePeriod) {
            <button class="btn btn-primary" type="button" (click)="add()" [disabled]="!canBeOrdered(selectedTaskType)">
              <i class="fa fa-plus"></i>Add
            </button>
          } @else {
            <div class="btn-group">
              <button type="button" class="btn btn-primary" [disabled]="!selectedTaskType || !canBeOrdered(selectedTaskType)" (click)="add()"><i class="fa fa-plus"></i>Add</button>
              <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-expanded="false" [disabled]="!selectedTaskType || !canBeOrdered(selectedTaskType)">
                <span class="visually-hidden">Toggle Dropdown</span>
              </button>
              <ul class="dropdown-menu" role="menu">
                @for ( quantity of qtyNumbers; track quantity ) {
                  <li class="text-center">
                    <button class="btn-link dropdown-item" [disabled]="qtyDisabled(quantity)" (click)="add(quantity)">{{ quantity }}</button>
                  </li>
                }
                @if (selectedTaskType && canBeNonworkable(selectedTaskType)) {
                  <div class="dropdown-divider"></div>
                  <li class="text-center">
                    <button class="btn-link dropdown-item" (click)='deactivate(selectedTaskType)'>Deactivate</button>
                  </li>
                }
              </ul>
            </div>
          }
        } @else {
          <button class="btn btn-primary" type="button" disabled="true">
            <i class="fa fa-plus"></i>Add
          </button>
        }
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-6" *ngIf="selectedTaskType">
    <div *ngIf="noAvailablePeriodsErrorMessage" class="alert alert-danger">
      <strong><i class="fas fa-stop-circle"></i> {{ noAvailablePeriodsErrorMessage }}</strong>
    </div>
    <div *ngFor="let flag of selectedTaskType.Flags">
      <ng-container *ngIf="!isNonworkableFlag(flag)">
        <app-components-managecustomer-allocatework-tasktypeflag [flag]="flag">
        </app-components-managecustomer-allocatework-tasktypeflag>
      </ng-container>
      <ng-container *ngIf="isNonworkableFlag(flag)">
        <app-components-managecustomer-allocatework-nonworkabletasktypeflag
          [flag]="flag"
          [customerId]="customerId"
          [taskTypeId]="selectedTaskType.TaskTypeId"
          [taskTypeName]="selectedTaskType.Name"
          (refresh)="refresh.emit()">
        </app-components-managecustomer-allocatework-nonworkabletasktypeflag>
      </ng-container>
    </div>
  </div>
</div>
